import { GET_PORTOFOLIO_START } from '../../types';

export const get_portofolio = (payload) => ({
  type: GET_PORTOFOLIO_START,
  payload,
});
